module.exports = require("./sv-AX.d.ts");